import React from 'react'
import { Redirect, Route, RouteProps } from 'react-router-dom'

type Props = {
  loggedIn: boolean
  redirect: string
} & RouteProps

export const OnlyUnauthRoute = ({ loggedIn, redirect, ...rest }: Props) => {
  return loggedIn ? <Redirect to={redirect} /> : <Route {...rest} />
}
